import {
    logFileResourceActions,
    logFileResourceThunks as defaultThunks,
    logFileResourceSelectors as defaultSelectors,
    logFileResourceReducer,
} from './LogFileResource-slice';
import * as thunks from './LogFileResource-thunks';
import * as selectors from './LogFileResource-selectors';

const logFileResourceThunks = { ...defaultThunks, ...thunks };
const logFileResourceSelectors = { ...defaultSelectors, ...selectors };

export {
    logFileResourceSelectors,
    logFileResourceActions,
    logFileResourceThunks,
    logFileResourceReducer,
};
